import type { Config } from './types';
import { env as nextEnv } from 'next-runtime-env';

/**
 * Get environment variable at runtime
 * Safe to use on both server-side and client-side
 * @param key Environment variable key
 * @returns Environment variable value
 */
export const env = <T extends keyof Config>(key: T) => nextEnv(key) ?? '';

export { getGTMId } from './gtm';
export { getMediaOrigin, isClient, isDevOrStaging, isServer } from './env';
